import {ComponentProps, useCallback} from 'react';
import {Control, FieldValues, Path, useController} from 'react-hook-form';

import {TextField} from 'components/TextField/TextField';

type Props<T extends FieldValues> = {
    control: Control<T>;
    name: Path<T>;
    validate?: (value: string) => boolean | string;
    format?: (value: string) => string;
} & Omit<ComponentProps<typeof TextField>, 'onChange' | 'value' | 'name'>;

export function TextFieldHookForm<T extends FieldValues>({
    control,
    validate,
    format,
    onFocus,
    ...textFieldProps
}: Props<T>) {
    const {
        field,
        fieldState: {error},
    } = useController({
        name: textFieldProps.name,
        control,
        rules: {
            required: textFieldProps.required ? 'Обязательное поле' : undefined,
            validate,
        },
    });

    const handleChange = useCallback(
        (value: string) => {
            const result = format ? format(value) : value;
            field.onChange(result);
        },
        [format, field],
    );

    return (
        <TextField
            {...textFieldProps}
            onChange={handleChange}
            onBlur={field.onBlur}
            onFocus={onFocus}
            value={field.value}
            error={error?.message}
        />
    );
}
